import React from 'react';
import styled from 'styled-components';

const Anchor = styled.a`
  color: #FFF;
  font-size: 12pt;
  text-decoration: none;
  width: fit-content;
  font-family: "Perroquet-Bold",Arial, Helvetica, sans-serif;
  box-shadow: inset 0 -1px 0 #7600ff, 0 1px 0 #7600ff;
  cursor: pointer;
  transition: box-shadow .45s ease-in-out;
  &:hover {
    box-shadow: inset 0 -25px 0 #7600ff, 0 1px 0 #7600ff;
  }
`;

const AncreHref = ({ url, children }) => {

  return (
    <Anchor href={url} target="_blank">
      {children}
    </Anchor>
  )
}

export default AncreHref
